import React from 'react';
import { Button, Modal } from 'components/ui';
import { TEXT_VARIANTS, Text } from 'components/ui/Typography';

const RemoveImageModal = ({
  shown,
  onDimss,
  currentCompany,
  type,
  onFileRemove,
}) => {
  return (
    <Modal
      className="uploader-modal"
      shown={shown}
      onDismiss={onDimss}
      enableFloatingDismiss
      canClickAway={false}
    >
      <div className="uploader-modal--body">
        <div className="ModalTakeover-title">
          <Text variant={TEXT_VARIANTS.TITLE}>
            {t('settings.tab.customization.remove_modal.title', {
              type,
            })}
          </Text>
        </div>
        <div className="ModalTakeover-content minh-50">
          <Text variant={TEXT_VARIANTS.BODY}>
            {t('settings.tab.customization.remove_modal.body', {
              company_name: currentCompany,
              type,
            })}
          </Text>

          <div className="d-f h-100 jc-e ai-c mt-20">
            <Button
              className="NewButton NewButton--gray mr-10"
              onClick={onDimss}
            >
              {t('settings.tab.customization.remove_modal.actions.cancel')}
            </Button>
            <Button className="NewButton" onClick={onFileRemove} customColor>
              {t('settings.tab.customization.remove_modal.actions.remove')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveImageModal;
